<template lang="pug">
.bems-event-card.z-depth-2.item.element-item.card
  .bems-card-header
    p {{ name }}
  .bems-card-img
    img(:src="img" :alt="description")
  .bems-card-content
    p {{description}}
  .bems-card-footer.z-depth-1
    span Sponsor: &nbsp;
    <router-link :to="{name: 'About', params: {listing: sponsor.link}}" class="chip z-depth-1 hoverable">{{sponsor.name}}</router-link>
</template>

<script>
import { db } from '../firebase-config.js'

export default {
  props: ['name', 'description', 'img', 'thekey'],
  data() {
    return {
      sponsor: ''
    }
  },
  firebase() {
    return {
      deals: db.ref('deals'),
      businesses: db.ref('businesses')
    }
  },
  methods: {
    getSponsor(key) {
      db.ref('businesses').child(key).on('value', snap => {
        this.sponsor = snap.val()
      })
    }
  },
  mounted() {
    this.getSponsor(this.thekey)
  }
}
</script>

<style scoped lang="stylus">
.chip {
  background-color: #555;
  color: #fff;
}

.deal-name {
  font-weight: bold;
  font-size: x-large;
}

.bems-event-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 300px;
  margin: 1em;
  border-radius: 1em;

  .bems-card-header, .bems-card-footer {
    display: flex;
    align-items: center;
    height: 50px;
    padding-left: 1em;

    h2 {
      font-size: 1.5em;
      font-weight: bold;
      color: white;
      white-space: nowrap;
    }
  }

  .bems-card-content {
    color: #fff;
    padding: 1em;
  }
}

.bems-card-img {
  img {
    width: 100%;
  }
}

.bems-card-header {
  justify-content: center;
  font-weight: bold;
  font-size: 20px;
}
</style>
